// extracted by mini-css-extract-plugin
module.exports = {"default":"ButtonIconPrimary_default__8Ivv4","inverse":"ButtonIconPrimary_inverse__U6KO4","fullWidth":"ButtonIconPrimary_fullWidth__PCqJP"};